export default "__VITE_ASSET__D20_bOQE__"